import { combineReducers } from 'redux';
import { Actions, ActionTypes } from './actions';

export const byPropertyId = (state = [], action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.DIRECT_DISCOUNT_GET_BY_PROP_ID_RECEIVE:
			return { ...state, [action.payload.propertyId]: action.payload.directDiscounts };
		default:
			return state;
	}
};

export interface IDirectDiscountState {
	byPropertyId: ReturnType<typeof byPropertyId>;
}

export default combineReducers<IDirectDiscountState>({
	byPropertyId,
});
